import {TableCols} from '../interfaces/static-data';
import {Validators} from "@angular/forms";

export const LEGAL_PROGRAMMES_SUPPLEMENT_TYPE_OPTIONS = [
  {
    id: 'Prospectus Supplement',
    displayValue: 'Prospectus Supplement'
  },
  {
    id: 'Registration Document Supplement',
    displayValue: 'Registration Document Supplement'
  }
]

export const LEGAL_PROGRAMMES_LANGUAGE_OPTIONS = [
  {
    id: 'English',
    displayValue: 'English'
  },
  {
    id: 'German',
    displayValue: 'German'
  }
]

export const LEGAL_PROGRAMMES_BASE_PROSPECTUS_CATEGORY_OPTIONS = [
  {
    id: 'Warrants',
    displayValue: 'Warrants'
  },
  {
    id: 'Certificates',
    displayValue: 'Certificates'
  },
  {
    id: 'Notes',
    displayValue: 'Notes'
  },
  {
    id: 'CLNs (Public Offers)',
    displayValue: 'CLNs (Public Offers)'
  },
  {
    id: 'CLN (Private Placement)',
    displayValue: 'CLN (Private Placement)'
  }
]

export const LEGAL_PROGRAMMES_APPROVING_AUTHORITY_OPTIONS = [
  {
    id: 'BaFin',
    displayValue: 'BaFin'
  },
  {
    id: 'CSSF',
    displayValue: 'CSSF'
  }
];

export const LEGAL_PROGRAMMES_STATUS_OPTIONS = [
  {
    id: 'Active',
    displayValue: 'Active'
  },
  {
    id: 'Inactive',
    displayValue: 'Inactive'
  }
]

export const LEGAL_PROGRAMMES: TableCols[] = [
  {
    key: 'status',
    displayValue: 'Status',
    type: 'select',
    items: LEGAL_PROGRAMMES_STATUS_OPTIONS,
    defaultValue: 'Active',
    validators: [Validators.required],
  },
  {
    key: 'issuerId',
    displayValue: 'Issuer',
    type: 'select',
    validators: [Validators.required],
    defaultValue: null
  },
  {
    key: 'name',
    displayValue: 'Name',
    validators: [Validators.required],
    defaultValue: null
  },
  {
    key: 'description',
    displayValue: 'Description',
    validators: [Validators.required],
    defaultValue: null
  },
  {
    key: 'programmeDate',
    displayValue: 'Programme Date',
    type: 'date',
    validators: [Validators.required],
    defaultValue: null
  },
  {
    key: 'validUntilDate',
    displayValue: 'Validity End Date',
    type: 'date',
    defaultValue: null
  },
  {
    key: 'approvingAuthority',
    displayValue: 'Approving Authority',
    type: 'select',
    items: LEGAL_PROGRAMMES_APPROVING_AUTHORITY_OPTIONS,
    validators: [Validators.required],
    defaultValue: null
  },
  {
    key: 'authorityApprovalDate',
    displayValue: 'Authority Approval Date',
    type: 'date',
    defaultValue: null
  },
  {
    key: 'prospectusId',
    displayValue: 'Prospectus ID',
    defaultValue: null
  },
  {
    key: 'baseProspectusCategory',
    displayValue: 'Base Prospectus Product Categories',
    type: 'select',
    items: LEGAL_PROGRAMMES_BASE_PROSPECTUS_CATEGORY_OPTIONS,
    validators: [Validators.required],
    defaultValue: null
  },
  // {
  //   key: 'defaultProspectus',
  //   displayValue: 'Default prospectus for relevant product category, language and approving authority?'
  // },
  {
    key: 'language',
    displayValue: 'Language',
    type: 'select',
    items: LEGAL_PROGRAMMES_LANGUAGE_OPTIONS,
    defaultValue: null
  },
  {
    key: 'documentRegistrationDate',
    displayValue: 'Date of Registration Document',
    type: 'date',
    defaultValue: null
  },
  {
    key: 'documentApprovalDate',
    displayValue: 'Registration Document Approval Date',
    type: 'date',
    defaultValue: null
  },
  {
    key: 'initialSupplementCounter',
    displayValue: 'Supplement Counter',
    type: 'number',
    defaultValue: 999
  },
  {
    key: 'nextSupplementCounter',
    displayValue: 'Next Supplement Counter',
    type: 'number',
    defaultValue: 1000
  },
  {
    key: 'supplements',
    displayValue: 'Supplements',
  },
  {
    key: 'workflowStatus',
    displayValue: 'Workflow Status',
    hideOnForm: true
  },
  {
    key: 'lastUpdatedBy',
    displayValue: 'Last Updated By',
    hideOnForm: true
  },
  {
    key: 'updatedOn',
    displayValue: 'Updated On',
    hideOnForm: true
  },
  {
    key: 'deletedAt',
    displayValue: 'Deleted On',
    hideOnForm: true
  }
];
